module.exports = __webpack_public_path__ + "img/marker.ddb07ab8.svg";